import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-create-family-validator',
  templateUrl: './create-family-validator.component.html',
  styleUrls: ['./create-family-validator.component.scss']
})
export class CreateFamilyValidatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  
  static dateValidator(formGroup: FormGroup) {
    const orderDeadlineDate = formGroup.get('orderDeadlineDate')?.value;
    const orderSupplierDate = formGroup.get('orderSupplierDate')?.value;
    const orderDeliveryDate = formGroup.get('orderDeliveryDate')?.value;

    const deadlineDate = orderDeadlineDate ? new Date(orderDeadlineDate.year, orderDeadlineDate.month - 1, orderDeadlineDate.day) : null;
    const orderDate = orderSupplierDate ? new Date(orderSupplierDate.year, orderSupplierDate.month - 1, orderSupplierDate.day) : null;
    const deliveryDate = orderDeliveryDate ? new Date(orderDeliveryDate.year, orderDeliveryDate.month - 1, orderDeliveryDate.day) : null;

    if (deadlineDate && orderDate && deadlineDate > orderDate) {
      return { deadlineAfterOrder: true };
    }
    
    if (orderDate && deliveryDate && orderDate > deliveryDate) {
      return { orderAfterDelivery: true };
    }
  
    return null;
  }
}
